import * as React from "react";
import "./SuccessPage.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import sucesss_page from "../../img/sucesss_page.png";
export interface ISuccessPageProps {
  click: (etat: boolean) => void;
}

export default function SuccessPage(props: ISuccessPageProps) {
  return (
    <div className="sucesss_page">
      <div className="close_btn" onClick={() => props.click(false)}>
        <p>Close</p>
        <FontAwesomeIcon icon={faTimes} />
      </div>
      <h1 className="request_sent">Your request has been sent</h1>
      <p className="reach_text">We will reach out to you as soon as possible</p>
      <img src={sucesss_page} alt="" />
    </div>
  );
}
